import Component from '@ember/component';
import { action, computed, get, set } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import Changeset from 'ember-changeset';

// attrs
// - contact
//
// actions
// - onSave
//   - arg1 = save() promise
// - onCancel
export default Component.extend({
  classNames: ['pt-2'],
  media: service(),
  changeset: null,

  didInsertElement() {
    this._super(...arguments);
    setTimeout(() => {
      this.element.querySelector('input').focus();
    }, 0);
  },

  showCard: alias('media.isMediumDown'),
  // Whether all the fields should be stacked or not
  stackedLayout: computed('media.{isExtraLarge,isMedium,isSmall}', function () {
    return !(
      get(this, 'media.isExtraLarge') ||
      get(this, 'media.isMedium') ||
      get(this, 'media.isSmall')
    );
  }),

  didReceiveAttrs() {
    this._super(...arguments);
    let contact = this.contact;
    let changeset = new Changeset(contact);
    set(this, 'changeset', changeset);
  },

  save: action(function () {
    let changeset = this.changeset;
    this.onSave(changeset.save());
  }),

  cancel: action(function () {
    this.onCancel();
  }),
});
